
<template>
    <b-modal ref="profile_modal" size="xl"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw
    >

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
					<span class="fw-300">

					</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-container show">
                        <div class="panel-content mb-0">

                        </div>
                    </div>
                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">

            </div>
        </template>
    </b-modal>
</template>

<script>
import Yes_no from "../../../../sys/radio/yes_no.vue";

export default {
    name: "ai_prod_image",
    components: {Yes_no},
    props: {
        product: {
            type: Object
        }
    },
    data() {
        return {
            is_show_modal: false,
            is_load: false,

        }
    },

    created() {
        EventBus.$on('show_ai_image',this.work_image);
    },

    methods: {

        work_image() {
            this.is_show_modal = true;
            this.is_load = true;

            this.ai_image();
        },

        async ai_image() {
            await api.get('/internal/v1/ai/suggest/products/image/'+ this.product.id,).then(({data}) => {
                this.is_ai_work = false;
                if (data.status === "operation_success") {

                }
            })
            .catch(({response}) => {
                this.is_ai_work = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        close_modal() {
            this.close()
        },
        close() {
            this.is_show_modal = false;
        },
    },

    computed : {
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-sm";
            }

            return "modal-dialog-right modal-sm";
        },
    }

}
</script>


<style scoped>

</style>
